import * as yup from "yup";
import { PermissionsType } from "../types/permissions";

const profileSchema = yup.object().shape({
    name: yup.string().required("Este campo es requerido."),
    permissions: yup.array<PermissionsType>()
        .test("atLeastOne", "Elija al menos un permiso,", (value) => value && value.length > 0)
});

export {
    profileSchema
}